module.exports = __webpack_public_path__ + "img/5.4aa87d26.jpg";